module.exports = __webpack_public_path__ + "img/diamonds.2230a03.png";